<template>
	<div>
		<b-row>
			<b-col class="mb-4" md="12">
				<h6>Single Selected</h6>
				<active-module-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col class="mb-4" md="12">
				<h6>Single Selected</h6>
				<active-module-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col class="mb-4" md="12">
				<h6>Multiple Selected</h6>
				<active-module-selectbox v-model="value3" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import ActiveModuleSelectbox from "@/components/interactive-fields/ActiveModuleSelectbox.vue";

	export default {
		components: {
			ActiveModuleSelectbox
		},
		data() {
			return {
				value1: null,
				value2: 1,
				value3: 1,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 3;
				this.value3 = 3;
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

